export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4 no-underline">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-fill text-lg text-background-50"></i>
                </div>
                <span className="text-xl font-heading tracking-wider text-foreground-950">黄瓜影院</span>
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                黄瓜影院致力于为观众提供高清影视在线观看服务，汇集海量免费电视剧全集和最新电影大全。高清画质、流畅播放、智能推荐，让每一次观影都成为享受。
              </p>
              <div className="flex items-center gap-3">
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-colors duration-200 cursor-pointer">
                  <i className="ri-mail-line text-sm"></i>
                </a>
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-colors duration-200 cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-colors duration-200 cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </span>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4 uppercase tracking-wider">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '特色优势', href: '#features' },
                  { label: '热门排行', href: '#ranking' },
                  { label: '最新动态', href: '#updates' },
                  { label: '常见问答', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a href={item.href} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4 uppercase tracking-wider">影视分类</h4>
              <ul className="space-y-2.5">
                {[
                  { label: '热门电视剧', href: '#cards' },
                  { label: '最新电影', href: '#cards' },
                  { label: '综艺节目', href: '#index' },
                  { label: '动漫番剧', href: '#index' },
                ].map((item) => (
                  <li key={item.href}>
                    <a href={item.href} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4 uppercase tracking-wider">合作伙伴</h4>
              <ul className="space-y-2.5">
                <li className="text-sm text-foreground-400">优质内容合作方</li>
                <li className="text-sm text-foreground-400">技术平台支持</li>
                <li className="text-sm text-foreground-400">版权合作机构</li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 黄瓜影院 版权所有 | 高清影视在线观看平台
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors duration-200">服务条款</span>
              <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors duration-200">隐私政策</span>
              <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors duration-200">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}